// extracted by mini-css-extract-plugin
export default {"cardsColumn":"RoomMovieCards_cardsColumn__R5uqu"};